export default __webpack_public_path__ + "static/media/loaderOrange.6bb5e1a8.svg";